export const environment = {
  production: true,
  publisher: 'emi',
  urlPortale: 'https://www.emi.it',
  syncUrlPortale: 'https://www.emi.it/transcode/importbook',
  syncCoversPortale: 'https://www.emi.it/transcode/importCovers',
  server: {
    url: 'https://elzeviro-emi.ilporticoeditoriale.it:3032'
  },
  copertinario: {
    media: 'https://elzeviro-edb.ilporticoeditoriale.it:3030/static/media/copertinario/',
    make: 'https://elzeviro-edb.ilporticoeditoriale.it:8080/copertinario/make'
  },
  recensioni: {
    media: 'https://elzeviro-emi.ilporticoeditoriale.it:3032/static/media/recensioni/'
  },
  extra: {
    media: 'https://elzeviro-emi.ilporticoeditoriale.it:3032/static/media/extra/'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts